import { shouldPolyfill } from '@formatjs/intl-pluralrules/should-polyfill';

function getLocale(locale) {
    if (locale === 'da-DK') return import(`@formatjs/intl-pluralrules/locale-data/da`);
    if (locale === 'sv-SE') return import(`@formatjs/intl-pluralrules/locale-data/se`);
    if (locale === 'nb-NO') return import(`@formatjs/intl-pluralrules/locale-data/no`);

    return import(`@formatjs/intl-pluralrules/locale-data/da`);
}

export default async function polyfill(locale) {
    const unsupportedLocale = shouldPolyfill(locale);
    // This locale is supported
    if (!unsupportedLocale) {
        return;
    }
    // Load the polyfill 1st BEFORE loading data
    await import('./locale');
    await import('@formatjs/intl-pluralrules/polyfill-force');
    await getLocale(locale);
}
